<script setup>
/**
 * FormControlModulecomponentsDisplayName
 * Composition-based wrapper for the standard Text form controller.
 * Dynamically updates visibility configurations based on whether a name field is active.
 */
import { watch, getCurrentInstance } from 'vue';
import FormControlTypeText from "../form-control-type/FormControlTypeText.vue";

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

// --- Watchers ---

/**
 * Deeply watches the data record to toggle field visibility rules.
 * Note: Uses 'visibility' instead of 'hidden' to prevent the component from
 * unmounting itself, ensuring this tracking loop stays alive.
 */
watch(() => props.currentData, (newValue) => {
    if (props.field) {
        props.field.visibility = newValue?.nameField === 0 ? 'hidden' : '';
    }
}, { deep: true, immediate: true });
</script>

<template>
    <FormControlTypeText
        v-bind="$props"
        v-on="$listeners"
    />
</template>